import { render } from "./PropoComponent.vue?vue&type=template&id=75fb887f&scoped=true"
import script from "./PropoComponent.vue?vue&type=script&lang=js"
export * from "./PropoComponent.vue?vue&type=script&lang=js"

import "./PropoComponent.vue?vue&type=style&index=0&id=75fb887f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75fb887f"]])

export default __exports__